import { FC } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { KTCard } from "src/resources/helpers";

type AlertFailedModalProp = {
  isModalOpen?: boolean;
  isModalClose?: () => void;
  processName: string;
  errorMessage?: string;
};

export const AlertFailed: FC<AlertFailedModalProp> = ({
  isModalOpen,
  isModalClose,
  processName,
  errorMessage,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        animation
        centered
        show={isModalOpen}
        scrollable={false}
        onHide={() => isModalClose && isModalClose()}
        onBackdropClick={() => isModalClose && isModalClose()}
      >
        <Modal.Header closeButton className="bg-light my-0 py-3">
          <Modal.Title data-testid="error-modal-title" className="fs-3">
            {processName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light my-0 py-0">
          <KTCard className="flex h-100 py-10">
            {errorMessage && (
              <div className="text-center">
                <p className="p-0 m-0 fs-5 text-danger">
                  {t("ExportOrder.Failed")}
                </p>
                <p className="p-0 m-0 fs-5 mt-2 fw-bolder text-danger">
                  {errorMessage}
                </p>
                <p className="p-0 m-0 fs-5 mt-2 px-2 text-danger">
                  {t("ExportOrder.Failed.Info")}
                </p>
              </div>
            )}
          </KTCard>
        </Modal.Body>
        <Modal.Footer className="bg-light my-0 py-3"></Modal.Footer>
      </Modal>
    </>
  );
};
